const ApiUrl = 'https://luisfarboleda.goldpos.com.co/apiGold/';

const ApiRaiz = 'https://luisfarboleda.goldpos.com.co/';


const BackgroundColor = '#4175CB';


export { ApiUrl, BackgroundColor,ApiRaiz }
